import { render, staticRenderFns } from "./modulo_edit.vue?vue&type=template&id=47056a72"
import script from "./modulo_edit.vue?vue&type=script&lang=js"
export * from "./modulo_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports